import { useState, useEffect } from "react";
import Episodes from "./episode";
import Origin from "../origin";
import Location from "./location";


function FullProfile({ character }) {
    const [details, setDetails] = useState(null);

    useEffect(() => {
        if (character) {
            setDetails(character);
        }
    }, [character]);

    if (!details) {
        return <div>Loading...</div>;
    }

    return(
        <>
            <div className="full-profile">
                <div>
                    <h2 style={
                        { color: "pink" }
                    }>{details.name}</h2>
                    <img src={details.image} alt={details.name} />
                    <p><strong>Species:</strong> {details.species}</p>
                    <div className="location">
                        <h3>Location:</h3>
                        <Location location_url={details.location.url}/>
                    </div>
                    <div className="origin">
                        <h3>Origin:</h3>
                        <Origin  origin_url={details.origin.url}/>
                    </div>
                </div>
                <div className="episode">
                    <h3>Featured Episodes:</h3>
                    <div className="episode-list">
                        {details.episode.map((ep, index) => (
                            <Episodes key={index} ep_api={ep} />
                        ))}
                    </div>
                </div>
            </div> 
        </>
    );
}

export default FullProfile;